import * as React from "react";
import { formatCurrency } from "../../helpers/format_currency";
import { AppliedFilter } from "../applied_filter/applied_filter";
import { Filter } from "../applied_filter/filter";
import { removePropertyFromFilter } from "../helpers/handle_remove_filter";
import { rangeProperty } from "../helpers/filter_url_serialization";

const filterKey = "price";
const serializedKey = "cena";
const displayName = "Cena";

export const PriceFilter: Filter = {
  key: "price",
  serialize: (appliedFilter) => {
    const priceFilter = appliedFilter[filterKey];
    return priceFilter !== undefined
      ? rangeProperty(serializedKey, priceFilter)
      : null;
  },
  deserialize: (urlSearchParams: URLSearchParams) => {
    const priceFilter = urlSearchParams.get(serializedKey);
    if (priceFilter !== null) {
      const range = priceFilter
        .split("-")
        .map((id) => parseInt(id))
        .filter((id) => !Number.isNaN(id));
      if (range.length === 2) {
        return { price: { gte: range[0] as number, lte: range[1] as number } };
      }
    }
    return {};
  },
  AppliedControlComponent: ({ appliedFilter, onRemove }) => {
    const priceFilter = appliedFilter[filterKey];
    if (priceFilter === undefined) {
      return null;
    }

    const name = `od ${formatCurrency(priceFilter.gte)} do ${formatCurrency(
      priceFilter.lte
    )}`;

    return (
      <AppliedFilter
        filterName={displayName}
        values={[{ id: 0, name }]}
        onRemove={() =>
          onRemove(removePropertyFromFilter(appliedFilter, filterKey))
        }
      />
    );
  },
};
